import Chart from 'chart.js';

window.wsp = window.wsp || {};
wsp.charts = (function (window, document, $) {

    'use strict';

    var createPointRadius = function (data, targetValue) {
        var result = [];
        data.forEach(function(element) {
            if (element.y === targetValue) {
                result.push(6)
            } else {
                result.push(0)
            }
        });
        return result;
    };

    return {
        createResidualValueChart: function (elementId, data, targetValue) {
            var canvas = document.getElementById(elementId),
                ctx = canvas.getContext('2d');

            var chart = new Chart(ctx, {
                type: 'line',
                data: {
                    datasets: [{
                        data: data,
                        label: 'main',
                        hidden: false,
                        borderColor: '#2588d9',
                        lineTension: 0,
                        fill: false,
                        pointBackgroundColor: '#2588d9',
                        // showLine: false,
                        pointRadius: createPointRadius(data, targetValue)
                    }]
                },
                options: {
                    maintainAspectRatio: false,
                    layout: {
                        padding: 0
                    },
                    legend: {
                        display: false,
                        labels: {
                            boxWidth: 0
                        }
                    },
                    tooltips: {
                        enabled: false
                    },
                    elements: {
                        point: {
                            hitRadius: 0,
                            hoverRadius: 0,
                            hoverBorderWidth: 0,
                            fillColor: '#2588d9'
                        }
                    },
                    scales: {
                        xAxes: [{
                            type: 'linear',
                            scaleLabel: {
                                display: true,
                                labelString: 'BAUJAHR',
                                fontColor: '#2588d9',
                                fontStyle: 'bold',
                                fontSize: 15,
                                padding: 10
                            },
                            gridLines: {
                                drawBorder: false,
                                color: "#ffffff",
                                lineWidth: 3,
                                zeroLineColor: 'white',
                                zeroLineWidth: 3
                            },
                            ticks: {
                                fontSize: 12,
                                fontColor: '#2588d9',
                                fontStyle: 'bold',
                                reverse: true,
                                padding: 20,
                                userCallback: function (value) {
                                    value = value.toString();
                                    /* value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");*/
                                    return value + '';
                                }
                            }
                        }],
                        yAxes: [{
                            scaleLabel: {
                                display: true,
                                labelString: 'DURCHSCHNITTSPREIS',
                                fontColor: '#2588d9',
                                fontStyle: 'bold',
                                fontSize: 15,
                                padding: 10
                            },
                            gridLines: {
                                drawBorder: false,
                                color: "#ffffff",
                                lineWidth: 3,
                                zeroLineColor: 'white',
                                zeroLineWidth: 3
                            },
                            ticks: {
                                fontSize: 15,
                                fontColor: '#2588d9',
                                fontStyle: 'bold',
                                padding: 20,
                                maxTicksLimit: 3,
                                beginAtZero: false,
                                userCallback: function (value) {
                                    value = value.toString();
                                    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    return value + '€';
                                }
                            }
                        }]
                    }
                }
            });
        },
        createValuePredictionChart: function (elementId, data, targetValue) {
            var canvas = document.getElementById(elementId),
                ctx = canvas.getContext('2d');

            var chart = new Chart(ctx, {
                type: 'line',
                data: {
                    datasets: [{
                        data: data,
                        label: 'main',
                        hidden: false,
                        borderColor: '#2588d9',
                        lineTension: 0,
                        fill: false,
                        pointBackgroundColor: '#2588d9',
                        // showLine: false,
                        pointRadius: createPointRadius(data, targetValue)
                    }]
                },
                options: {
                    maintainAspectRatio: false,
                    layout: {
                        padding: 0
                    },
                    legend: {
                        display: false,
                        labels: {
                            boxWidth: 0
                        }
                    },
                    tooltips: {
                        enabled: false
                    },
                    elements: {
                        point: {
                            hitRadius: 0,
                            hoverRadius: 0,
                            hoverBorderWidth: 0,
                            fillColor: '#2588d9'
                        }
                    },
                    scales: {
                        xAxes: [{
                            type: 'linear',
                            scaleLabel: {
                                display: true,
                                labelString: 'JAHR',
                                fontColor: '#2588d9',
                                fontStyle: 'bold',
                                fontSize: 15,
                                padding: 10
                            },
                            gridLines: {
                                drawBorder: false,
                                color: "#ffffff",
                                lineWidth: 3,
                                zeroLineColor: 'white',
                                zeroLineWidth: 3
                            },
                            ticks: {
                                fontSize: 12,
                                fontColor: '#2588d9',
                                fontStyle: 'bold',
                                reverse: false,
                                padding: 20,
                                userCallback: function (value) {
                                    value = value.toString();
                                    /* value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");*/
                                    return value + '';
                                }
                            }
                        }],
                        yAxes: [{
                            scaleLabel: {
                                display: true,
                                labelString: 'DURCHSCHNITTSPREIS',
                                fontColor: '#2588d9',
                                fontStyle: 'bold',
                                fontSize: 15,
                                padding: 10
                            },
                            gridLines: {
                                drawBorder: false,
                                color: "#ffffff",
                                lineWidth: 3,
                                zeroLineColor: 'white',
                                zeroLineWidth: 3
                            },
                            ticks: {
                                fontSize: 15,
                                fontColor: '#2588d9',
                                fontStyle: 'bold',
                                padding: 20,
                                maxTicksLimit: 3,
                                beginAtZero: false,
                                userCallback: function (value) {
                                    value = value.toString();
                                    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    return value + '€';
                                }
                            }
                        }]
                    }
                }
            });
        }
    }

})(window, document, jQuery);